import React, { useEffect, useState, useContext } from 'react';
import { isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';
import {
  ServicesResult,
  AllServices,
  ServiceColumn,
  ServicesCard,
  ServicesText,
  ServicesImage,
} from './styles/ThreeColumnServicesBlock.styled';
import { Container } from './styles/Container.styled';
import LoadMoreGenericBtn from './LoadMoreGenericBtn';

export default function Services({ data, dir, id }) {
  const [loadMore, setLoadMore] = useState(false);
  const [hasMore, setHasMore] = useState(data.servicesList.length > +data.itemsToDisplay);
  const [services, setServices] = useState(
    data.servicesList.length <= +data.itemsToDisplay
      ? data.servicesList
      : [...data.servicesList.slice(0, +data.itemsToDisplay)],
  );

  const handleLoadMore = () => setLoadMore(true);

  useEffect(() => {
    if (loadMore && hasMore) {
      const currentLength = +services.length;
      const isGrater = +currentLength < +data.servicesList.length;
      const nextResults = isGrater
        ? data.servicesList.slice(+currentLength, +currentLength + +data.itemsToDisplay)
        : [];
      setServices([...services, ...nextResults]);
      setLoadMore(false);
    }
  }, [loadMore, hasMore]);

  useEffect(() => {
    const isGrater = services.length < data.servicesList.length;
    setHasMore(isGrater);
  }, [services]);

  const { translations } = useContext(DWTCContext);

  return (
    <ServicesResult id="allServices">
      <Container id={id}>
        <AllServices>
          {isEmpty(services) ||
            services.map(({ content }) => (
              <ServiceColumn>
                <ServicesCard
                  href={isEmpty(content.link) || content.link.url}
                  className="service_card"
                >
                  <ServicesText dir={dir}>
                    <h3 dir={dir}>{content.title}</h3>
                    <p dir={dir} className="service_desc">
                      {content.subtitle}
                    </p>
                  </ServicesText>
                  <ServicesImage>
                    <LazyLoadImage
                      src={isEmpty(content.image) || content.image.url}
                      effect="blur"
                      placeholderSrc={
                        content.image ? `${content.image.url}?width=50&quality=50` : null
                      }
                      width="100%"
                      height="100%"
                    />
                  </ServicesImage>
                </ServicesCard>
              </ServiceColumn>
            ))}
        </AllServices>
        {hasMore && (
          <LoadMoreGenericBtn
            color="blue"
            position="center"
            label={getTranslationByKey(translations, 'Load More')}
            onClick={handleLoadMore}
            dir={dir}
          />
        )}
      </Container>
    </ServicesResult>
  );
}
